var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferbonus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2C3.79086 2 2 3.79086 2 6V18C2 20.2091 3.79086 22 6 22H18C20.2091 22 22 20.2091 22 18V6C22 3.79086 20.2091 2 18 2H6ZM8.59668 12.7041C8.76 12.4815 9.07324 12.4334 9.2959 12.5967C9.51851 12.76 9.5666 13.0732 9.40332 13.2959L7.9873 15.2275H17L17.1006 15.2373C17.3285 15.2839 17.5 15.4858 17.5 15.7275C17.4999 15.9691 17.3284 16.1702 17.1006 16.2168L17 16.2275H8.10645L9.375 17.6699L9.43457 17.752C9.55005 17.9538 9.51142 18.2154 9.33008 18.375C9.14879 18.5345 8.88472 18.5394 8.69922 18.3994L8.625 18.3301L6.625 16.0576C6.46992 15.8814 6.45791 15.621 6.59668 15.4316L8.59668 12.7041ZM14.7041 5.59668C14.8988 5.45388 15.1626 5.47302 15.335 5.62891L15.4033 5.7041L17.4033 8.43164C17.5421 8.62096 17.5301 8.8814 17.375 9.05762L15.375 11.3301C15.1926 11.5373 14.8772 11.5574 14.6699 11.375C14.4627 11.1926 14.4426 10.8772 14.625 10.6699L15.8936 9.22754H7C6.72395 9.22754 6.50014 9.00356 6.5 8.72754C6.5 8.4514 6.72386 8.22754 7 8.22754H16.0127L14.5967 6.2959L14.5449 6.20801C14.4481 5.99683 14.5095 5.73946 14.7041 5.59668Z",
    fill: "url(#paint0_linear_39_28436)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_39_28436",
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2B62E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#934600"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferbonus);
export default __webpack_public_path__ + "static/media/transferbonus.aa5cad831ddc3d00f81c2371aaedd8b1.svg";
export { ForwardRef as ReactComponent };